// src/utils/quotation-status.ts
import type { Tone } from "../components/delivery/atoms"
import { QuotationStatus } from "../models/Quotation"

export const BUYER_QUOTATION_STATUSES: QuotationStatus[] = [
  "SENT",
  "ACCEPTED",
  "REJECTED",
  "EXPIRED",
  "REVISED",
  "CANCELLED",
  "CONVERTED",
]

/** Status → DotPill tone (canvas OrdB_Quotes: ok = green, open = blue, revised = amber, stopped = red/grey). */
const STATUS_TONE: Partial<Record<QuotationStatus, Tone>> = {
  SENT: "blue",
  ACCEPTED: "green",
  CONVERTED: "green",
  REJECTED: "red",
  REVISED: "amber",
  EXPIRED: "grey",
  CANCELLED: "grey",
}

export function quotationStatusTone(status?: string): Tone {
  return STATUS_TONE[status as QuotationStatus] ?? "grey"
}
